import queryString from 'query-string';

// サインアップ時の流入元。Cognito のユーザー属性 custom:signup_tag に入れる。
//
// 流入元は UTM の utm_source で受け取る。Mixpanel が自動でイベントに載せる
// のは utm_source / utm_medium / utm_campaign / utm_content / utm_term の
// 5種だけで、独自の ref は Mixpanel からは見えないため。
//
// ref は docs.geolonia.com が以前まで付けていたパラメータで、外部のページや
// ブックマークに残っている分を取りこぼさないように読み続ける。

/** 同じ名前のパラメータが複数あるときは最初の値を使う。無い場合は空文字。 */
const firstValue = (value: string | (string | null)[] | null | undefined): string => {
  if (Array.isArray(value)) {
    return value[0] || '';
  }

  return value || '';
};

const signupReferrer = (search: string = window.location.search): string => {
  const query = queryString.parse(search);

  return firstValue(query.utm_source) || firstValue(query.ref);
};

export default signupReferrer;
